import { http } from '../../config/axios'

export default function postRedefinirSenha(request: any): Promise<string> {
  return http
    .post('api/gatewaybiro/changepassword', request)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro ao redefinir senha', error)
      throw Error(error.response.data)
    })
}
